import {Button, Form, List, ListInlineItem, ModalBody, ModalFooter} from "reactstrap";
import OTPInput from "react-otp-input";
import {AuthCustomModalDescriptionStyleB} from "../../../../layouts/auth/auth.layout.style";
import {useEffect, useState} from "react";
import {useAuth} from "../../../../providers/authentication.provider";
import {activateNotification} from "../../../../utils/notifications-utils";
import {useSearchParams} from "react-router-dom";
import {useNavigate} from "react-router";

export const VerifyOtpSection = ({pendingCredentials, onSuccess}) => {
    const [otp, setOtp] = useState("");
    const {activateAccount, login, resendOtp} = useAuth()
    const [responseErrors, setResponseErrors] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    useEffect(() => {
        if (otp === undefined || otp === null) setOtp("");
    }, [otp]);

    const onSubmit = async (e) => {
        e.preventDefault()
        if (otp.length < 6 || !pendingCredentials) return;
        const {username, password} = pendingCredentials;
        const {success, message, data} = await activateAccount({username, otp}, () => {
            setOtp("")
        });
        activateNotification({title: success ? "Success" : "Error", body: message});


        if (success) {
            const loginRes = await login({username, password});

            if (loginRes.success) {
                if (onSuccess) {
                    onSuccess()
                } else {
                    navigate(searchParams.get("redirect_to") || "/");
                }
                return
            }
            return navigate("/login");
        }
        if (data?.errors) return setResponseErrors(data.errors);
    }

    const resendOtpHandler = async () => {
        if (!pendingCredentials) return;
        const {username, email, phone_number} = pendingCredentials;
        const {success, message, data} = await resendOtp({username: username || email || phone_number});
        activateNotification({title: success ? "Success" : "Error", body: message});
        if (data?.errors) setResponseErrors(data.errors);
    }
    return (<Form onSubmit={onSubmit}>
        <div>
            <div className={"otp-input"}>
                <OTPInput
                    inputStyle="inputStyle"
                    numInputs={6}
                    renderSeparator={<span>-</span>}
                    value={otp || ""}
                    onChange={(otp) => setOtp(otp)}
                    inputType={'number'}
                    containerStyle={{
                        justifyContent: "space-evenly", maxWidth: "400px", margin: "auto"
                    }}
                    placeholder={''}
                    renderInput={(props) => <input {...props} style={{width: "100%"}}
                                                   className={`otp-input-number text-center ${props.className || ""}`}/>}
                    shouldAutoFocus
                />
            </div>
            {responseErrors.length > 0 && (<List type={"inline"}>
                {responseErrors.map((error, index) => (<ListInlineItem className={"tw-text-red-500"}
                                                                       key={index}>{error}</ListInlineItem>))}
            </List>)}
            <div className="d-flex justify-content-center mt-2">
                <AuthCustomModalDescriptionStyleB>Didn't receive any otp?
                    <span style={{cursor: "pointer"}} className={"link tw-cursor-pointer"}
                          onClick={resendOtpHandler}>Resend OTP</span>
                </AuthCustomModalDescriptionStyleB>
            </div>
        </div>
        <ModalFooter>
            <AuthCustomModalDescriptionStyleB className="my-md-4 tw-text-center my-2">
                By proceeding, you agree to our <a href="/terms-and-conditions">Terms of Use</a> and <a
                href="/privacy-policy">Privacy Policy</a>
            </AuthCustomModalDescriptionStyleB>
            <Button disabled={otp.length < 6}>
                <span>Verify Otp</span>
            </Button>
        </ModalFooter>
    </Form>)
}